import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { trackProductEvents } from "@/services/marketingApi";

const SESSION_KEY = "amos_pa_session";

/** Fire-and-forget AMOS product page views (authenticated shell only). */
export function useProductPageTracking() {
  const location = useLocation();
  const lastPath = useRef("");

  useEffect(() => {
    const path = location.pathname || "/";
    if (path === lastPath.current) return;
    lastPath.current = path;

    const events: Array<{ name: "session_start" | "page_view"; path: string }> = [];
    if (!sessionStorage.getItem(SESSION_KEY)) {
      sessionStorage.setItem(SESSION_KEY, "1");
      events.push({ name: "session_start", path });
    }
    events.push({ name: "page_view", path });

    void trackProductEvents(events).catch(() => {
      /* non-blocking */
    });
  }, [location.pathname]);
}
